(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDeleteController',ConexionesDeleteController);

    ConexionesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Conexiones'];

    function ConexionesDeleteController($uibModalInstance, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Conexiones.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
